import React from 'react';

const TermsPage = () => (
  <div className="max-w-4xl mx-auto px-4 py-10">
    <h1 className="text-3xl font-bold text-green-700 mb-4">Terms & Conditions</h1>
    <p className="mb-4 text-gray-700">
      By using JanShakti, you agree not to post hate speech, personal abuse, caste/religion-based content, or false information.
    </p>
    <p className="mb-4 text-gray-700">
      JanShakti reserves the right to moderate and remove any content deemed harmful or misleading. Users are responsible for the accuracy of their submissions.
    </p>
  </div>
);

export default TermsPage;
